__turbopack_context__.v({
  "categoryList": "CategoryNavigation-module-scss-module__Vd0F3W__categoryList",
  "categoryNav": "CategoryNavigation-module-scss-module__Vd0F3W__categoryNav",
  "categoryNavButton": "CategoryNavigation-module-scss-module__Vd0F3W__categoryNavButton",
  "categoryNavButtonIcon": "CategoryNavigation-module-scss-module__Vd0F3W__categoryNavButtonIcon",
  "categoryNavGridContainer": "CategoryNavigation-module-scss-module__Vd0F3W__categoryNavGridContainer",
  "categoryNavHeading": "CategoryNavigation-module-scss-module__Vd0F3W__categoryNavHeading",
  "categoryNavHeadingLink": "CategoryNavigation-module-scss-module__Vd0F3W__categoryNavHeadingLink",
  "categoryNavImage": "CategoryNavigation-module-scss-module__Vd0F3W__categoryNavImage",
  "categoryNavInner": "CategoryNavigation-module-scss-module__Vd0F3W__categoryNavInner",
  "categoryNavSubText": "CategoryNavigation-module-scss-module__Vd0F3W__categoryNavSubText",
});
